import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compact from 'lodash.compact';
import { QueryRenderer, graphql } from 'react-relay/compat';
import OverlaySpinner from 'dibs-overlay-spinner';

import { getUserId, cookieJarConstants, isMasqueradingAsBuyer } from 'dibs-cookie-jar';

import { procurementCta as copy } from '../../../../../json/copy/pdp.json';

import recentHistory from '../../../global/modules/recentHistory/recentHistory';

import styles from './TradeProcurementCta.scss';
import { getEnvironment } from '../../../global/relayEnvironmnentProvider.es';

const environment = getEnvironment();
const isMasquerading = isMasqueradingAsBuyer(document.cookie);

function loadTradeProcurement({ itemIds, additionalItemIds = [], skipHoldRequest }) {
    // eslint-disable-line react/prop-types
    if (!additionalItemIds.length) {
        const recentHistoryList = recentHistory.getList(null, null, 7);
        additionalItemIds = recentHistoryList.map(historyItem => historyItem.itemId);
        additionalItemIds.pop();
    }

    return System.import('dibs-trade-procurement').then(
        ({ TradeProcurementContainer, TradeProcurementContent }) => {
            const query = graphql`
                query TradeProcurementRendererQuery(
                    $userId: String = ""
                    $hasUserId: Boolean = false
                    $additionalItemIds: [String]
                ) {
                    viewer {
                        ...TradeProcurementContent_viewer
                    }
                }
            `;

            const userId = getUserId(
                document.cookie,
                cookieJarConstants[isMasquerading ? 'MASQUERADE_BUYER' : 'USER']
            );

            return (
                props // eslint-disable-line react/display-name
            ) => (
                <TradeProcurementContainer {...props}>
                    <QueryRenderer
                        environment={environment}
                        query={query}
                        variables={{
                            userId,
                            hasUserId: !!userId,
                            additionalItemIds,
                        }}
                        render={({ props: relayProps, error }) => { // eslint-disable-line react/display-name,react/prop-types
                            if (error) {
                                return <div>{copy.errorMessage}</div>;
                            }

                            if (relayProps) {
                                return (
                                    <TradeProcurementContent
                                        skipHoldRequest={skipHoldRequest}
                                        itemIds={itemIds}
                                        {...relayProps}
                                    />
                                );
                            }

                            return (
                                <OverlaySpinner
                                    additionalWrapperClasses={styles.overlaySpinner}
                                    size="medium"
                                    position="isRelative"
                                />
                            );
                        }}
                    />
                </TradeProcurementContainer>
            );
        }
    );
}

class TradeProcurementRenderer extends Component {
    constructor() {
        super();
        this.state = {
            TradeProcurementContainer: null,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.isOpen && nextProps.isOpen && !this.state.TradeProcurementContainer) {
            const { itemIds, additionalItemIds, isRemoveContactDealerCTATestRunning } = nextProps;
            loadTradeProcurement({
                itemIds: compact(itemIds),
                additionalItemIds,
                skipHoldRequest: isRemoveContactDealerCTATestRunning,
            }).then(TradeProcurementContainer => {
                this.setState({ TradeProcurementContainer });
            });
        }
    }

    render() {
        const { isOpen, closeModal, isRemoveContactDealerCTATestRunning } = this.props;
        const { TradeProcurementContainer } = this.state;

        if (TradeProcurementContainer) {
            return (
                <TradeProcurementContainer
                    isOpen={isOpen}
                    closeModal={closeModal}
                    skipHoldRequest={isRemoveContactDealerCTATestRunning}
                />
            );
        }

        return null;
    }
}

TradeProcurementRenderer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    itemIds: PropTypes.arrayOf(PropTypes.string),
    isRemoveContactDealerCTATestRunning: PropTypes.bool,
};

TradeProcurementRenderer.defaultProps = {
    isRemoveContactDealerCTATestRunning: false,
};

export default TradeProcurementRenderer;



// WEBPACK FOOTER //
// ./assets/js/global/components/TradeProcurement/TradeProcurementRenderer.jsx